<template lang="html">
	<div
	id="results"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section1-container">
		<h1 class="section-title">Results</h1>
		<div class="site-performance">
			<div class="metric-container">
				<h1>20,000+</h1>
				<p>Organic Visitors</p>
			</div>
			<div class="metric-container">
				<h1>1,500+</h1>
				<p>Downloads</p>
			</div>
			<div class="metric-container">
				<h1>100+</h1>
				<p>Countries</p>
			</div>
			<div class="metric-container">
				<h1>$0</h1>
				<p>Paid Media</p>
			</div>
		</div>
		<EnivornmentMath/>
	</div>
</template>

<script>
import EnivornmentMath from '@/components/partials/EnivornmentMath'
import sal from "sal.js"; // No need to use in main.js file

export default {
	mounted() {
			sal();
	},
	components: {
		EnivornmentMath
	}
}
</script>

<style scoped lang="scss">
.section1-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	.section-title {
		text-decoration: underline;
		text-decoration-color: $main-2;
	}
	h1 {
		padding-top:50px;
		font-size:40px;
		color: black;
		font-weight: 800;
    font-size: 3rem;
    font-family: ITCSouvenirBold;
    z-index: 1000;
	}
	p{
		color: $main-2;
		font-family: ITCSouvenirBold;
	}
}
    
</style>